// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.header {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 0 0 5px 0;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
}

.subheader {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
  min-height: 18pt;
  display: flex;
  align-items: center;
}

.caption {
  font-size: 13px;
  font-weight: normal;
  margin: 0;
  min-height: 18pt;
  display: flex;
  align-items: center;
}

.bottom-text-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 5px solid #1B3E78;
  margin-top: 10px;
  padding-top: 5px;
}
.bottom-text-container p {
  font-family: "Arial";
  font-size: 11px;
  color: rgb(158, 158, 158);
  line-height: 15px;
  margin: 0;
}

.main-container {
  overflow: hidden;
  padding: 0 10px 0 10px;
  height: 100%;
}

.main-container-iframe {
  overflow: hidden;
  padding: 0 10px 0 10px;
}

.plot {
  overflow: hidden;
  padding: 0 20px 0 0;
}

app-loader {
  vertical-align: center;
}

@media (max-width: 767px) {
  .main-container-iframe {
    width: 90vw;
  }
  .bottom-text-container {
    padding: 5px 10px 0;
  }
}
.caption[contenteditable=true] {
  background-color: #fcf8e3 !important; /* Light yellow */
  border: 1px solid #ff5733 !important; /* Orange */
  padding: 5px; /* Optional: Adds spacing */
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/shared/toolbox/charts/pie-chart/pie-chart.component.scss","webpack://./src/theme/variables.scss","webpack://./src/app/shared/toolbox/charts/chartsCommonStyles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;ACNA;EACI,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,mBAAA;AFgHJ;;AE3GA;EACI,yCAAA;EACA,eAAA;EACA,mBAAA;EAEA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AF6GJ;;AE1GA;EACI,eAAA;EACA,mBAAA;EAEA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AF4GJ;;AEzGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AF4GJ;AEzGI;EACI,oBAAA;EAAqB,eAAA;EACrB,yBAAA;EACA,iBAAA;EACA,SAAA;AF4GR;;AEvGA;EAEI,gBAAA;EACA,sBAAA;EACA,YAAA;AFyGJ;;AErGA;EACI,gBAAA;EACA,sBAAA;AFwGJ;;AEpGA;EAEI,gBAAA;EACA,mBAAA;AFsGJ;;AElGA;EACI,sBAAA;AFqGJ;;AElGA;EASI;IACI,WAAA;EF6FN;EE1FA;IACE,mBAAA;EF4FF;AACF;AA3LA;EACE,oCAAA,EAAA,iBAAA;EACA,oCAAA,EAAA,WAAA;EACA,YAAA,EAAA,2BAAA;AA6LF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import '../chartsCommonStyles.scss';\n.caption[contenteditable=\"true\"] {\n  background-color: #fcf8e3 !important; /* Light yellow */\n  border: 1px solid #ff5733 !important; /* Orange */\n  padding: 5px; /* Optional: Adds spacing */\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import \"variables\";\n.header {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:clamp(16px, 18px, 24px);\n    font-weight:bold;\n    text-align: left;\n\n    margin: 0 0 5px 0;\n    height:fit-content;\n    //min-height:42pt;\n    display:flex;\n    align-items: center;\n\n\n}\n\n.subheader {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:clamp(14px,16px,22px);\n    font-weight:normal;\n\n    margin:0;\n    min-height: 18pt;\n    display:flex;\n    align-items: center;\n}\n\n.caption {\n    font-size:clamp(11px, 13px, 18px);\n    font-weight:normal;\n\n    margin:0;\n    min-height: 18pt;\n    display:flex;\n    align-items: center;\n}\n\n.bottom-text-container {\n    display:flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 5px solid $dark-text;\n    margin-top: 10px;\n    padding-top: 5px;\n    //padding: 5px 5px 0 5px;\n\n    p { //source and chartid together\n        font-family: 'Arial';font-size: clamp(10px, 11px, 15px);\n        color: rgb(158, 158, 158);\n        line-height:15px;\n        margin:0\n    }\n\n}\n\n.main-container {\n\n    overflow: hidden;\n    padding:0 10px 0 10px;\n    height: 100%;\n\n}\n\n.main-container-iframe {\n    overflow: hidden;\n    padding:0 10px 0 10px;\n\n}\n\n.plot {\n    //height:300px;\n    overflow:hidden;\n    padding: 0 20px 0 0;\n\n}\n\napp-loader {\n    vertical-align: center;\n}\n\n@media (max-width: 767px) {\n    .main-container {\n\n        // min-width:350px;\n        //width:380px;\n        //max-width: 75vw;\n\n    }\n\n    .main-container-iframe{\n        width: 90vw;\n    }\n\n  .bottom-text-container {\n    padding: 5px 10px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
